module.exports = __webpack_public_path__ + "images/emoji/oncoming_bus.80b56b5a7b236837000b.png";